/** @format */

import React from "react";

// auth
import ConfirmMail from "../../views/dashboard/auth/confirm-mail";
import LockScreen from "../../views/dashboard/auth/lock-screen";

// errors
import Error404 from "../../views/dashboard/errors/error404";
import Error500 from "../../views/dashboard/errors/error500";

//extrpages
import LandingPage from "../../views/landing/page/page";
import UserSignIn from "../../views/dashboard/auth/user-auth";
import EmpSignIn from "../../views/dashboard/auth/emp-sign-in";
import UserSignUp from "../../views/dashboard/auth/user-auth/user-sign-up";
import UserForgotPassword from "../../views/dashboard/auth/forgot-pwd/user-forgot-password";
import OTP from "../../views/dashboard/auth/otp/otp-page";
import ForgotPwd from "../../views/dashboard/auth/forgot-pwd/forgot-pwd-cfm";

export const AuthRouter = [
  {
    key: "landing",
    path: "auth/landing",
    element: <LandingPage />,
  },
  {
    key: "confirm-mail",
    path: "auth/confirm-mail",
    element: <ConfirmMail />,
  },
  {
    key: "lock-screen",
    path: "auth/lock-screen",
    element: <LockScreen />,
  },
  {
    key: "recoverpw",
    path: "auth/recoverpw",
    element: <UserForgotPassword />,
  },
  {
    key: "otp-page",
    path: "auth/otp",
    element: <OTP />,
  },
  {
    key: "pwd-cfm-page",
    path: "auth/pwd-cfm",
    element: <ForgotPwd />,
  },
  {
    key: "forgotpw",
    path: "auth/forgotpw",
    element: <UserForgotPassword />,
  },
  {
    key: "user-sign-in",
    path: "auth/sign-in/user",
    element: <UserSignIn />,
  },
  {
    key: "employer-sign-in",
    path: "auth/sign-in/employer",
    element: <EmpSignIn />,
  },
  {
    key: "sign-up",
    path: "auth/sign-up",
    element: <UserSignUp />,
  },
  {
    key: "error404",
    path: "errors/error404",
    element: <Error404 />,
  },
  {
    key: "error500",
    path: "errors/error500",
    element: <Error500 />,
  },
];
